import Analytics from '../../../../analytics';

export const faOnMessageShown = type => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.USER_ACTION,
    event_name: Analytics.EVENT_NAMES.BUTTON_CLICK,
    event_value: `Message_shown|${type}`,
  });
};

export const faOnMessageClose = type => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.USER_ACTION,
    event_name: Analytics.EVENT_NAMES.BUTTON_CLICK,
    event_value: `Message_close|${type}`,
  });
};
